import { useCallback } from 'react';
import {
  TPanelIdentifier,
  eventsController,
  usePanelFireEvent,
} from '../eventsController';

export function changePanelTitle(
  identifier: TPanelIdentifier,
  newTitle: string,
) {
  eventsController.fireEvent(identifier, '__changePanelTitle__', newTitle);
}

export function usePanelChangeTitle() {
  const fireEvent = usePanelFireEvent();

  return useCallback(
    (newTitle: string) => {
      fireEvent('__changePanelTitle__', newTitle);
    },
    [fireEvent],
  );
}
